/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getHomeLoanById,
  updateHomeLoan,
  getAllAdmins,
  getAllCities,
  getHomeLoanByMobile,
  getAllStates,
  getAllPincode,
  getHomeLoanByEmail,
  getAllHomeLoanBanks,
  getAllCompanies,
  getBusinessLoanBankList,
  getDoctorLoanBankList,
  getPersonalLoanBankList,
  getNriLoanBankList,
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { FaTrashAlt, FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import CreateCompanyModal from "../Company/CreateComapnyModal";


const EditHomeLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [filteredStates, setFilteredStates] = useState([]);
  const [error, setError] = useState(null);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [mobileExists, setMobileExists] = useState(false);
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId, isLoggedIn } = useContext(AuthContext);
  const [status, setStatus] = useState("");
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [officeState, setOfficeState] = useState(null);
  const [officeCityOptions, setOfficeCityOptions] = useState([]);
  const [officePincodeOptions, setOfficePincodeOptions] = useState([]);
  const [clinicState, setClinicState] = useState(null);
  const [clinicCityOptions, setClinicCityOptions] = useState([]);
  const [clinicPincodeOptions, setClinicPincodeOptions] = useState([]);
  const [hospitalState, setHospitalState] = useState(null);
  const [hospitalCityOptions, setHospitalCityOptions] = useState([]);
  const [hospitalPincodeOptions, setHospitalPincodeOptions] = useState([]);
  const [companyId, setCompanyId] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState([]);
  const [companyName, setCompanyName] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [businessLoanBanks, setBusinessLoanBanks] = useState([]);
  const [doctorLoanBanks, setDoctorLoanBanks] = useState([]);
  const [personalLoanBanks, setPersonalLoanBanks] = useState([]);
  const [nriLoanBanks, setNriLoanBanks] = useState([]);
  const [files, setFiles] = useState({});
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);

  const fileRefs = {
    pan: useRef(null),
    aadhar: useRef(null),
    fmb_document: useRef(null),
    account_Statement: useRef(null),
    dtcp_document: useRef(null),
    parent_document: useRef(null),
    register_document: useRef(null),
    patta_chitta_doc: useRef(null),
    ec_document: useRef(null),
    panchayat_document: useRef(null),
    engineer_estimate_doc: useRef(null),
    gst_document: useRef(null),
    itr_document: useRef(null),
    msme_document: useRef(null),
    payslip: useRef(null),
    photo: useRef(null),
    others: useRef(null),
  };
  
  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      rejected_reason: "",
      name: "",
      dob: "",
      age: "",
      mobile: "",
      email: "",
      father_name: "",
      mother_name: "",
      marital_status:" ",
      spouse_name: "",
      residence_type: "",
      address: "",
      landmark: "",
      state: "",
      city: "",
      pincode: "",
      present_address_adhaar: "",
      present_address: "",
      present_state: "",
      present_city: "",
      present_pincode: "",
      present_landmark: "",
      required_loan_amount: "",
      existing_emi_amount: "",
      are_you: "",
      company_name: "",
      net_salary: "",
      is_pf_deducted: "",
      total_experience: "",
      company_type: "",
      type_your_designation: "",
      office_address: "",
      office_landmark: "",
      office_state: "",
      office_city:" ",
      office_pincode: "",
      register_company: "",
      turnover: "",
      business_type: "",
      description: "",
      business_place: "",
      businessStart_year: "",
      gst_registered: "",
      gst_registerd_year: "",
      msme_registered: "",
      degree: "",
      mbbs_completed_year: "",
      degree_others: "",
      work_type: "",
      service_experience: "",
      clinic_name: "",
      clinic_address: "",
      clinic_state: "",
      clinic_city: "",
      clinic_pincode: "",
      hospital_name: "",
      hospital_address: "",
      hospital_state: "",
      hospital_city: "",
      hospital_pincode: "",
      working_country: "",
      net_salary_indian_rupees: "",
      present_india: "",
      add_reference: "",
      reference_name: "",
      reference_mobile: "",
      reference_address: "",
      reference_location: "",
      bank_name: "",
      others_company: "",
      other: "",
      pan: null,
      aadhar: null,
      fmb_document: null,
      account_Statement: null,
      dtcp_document: null,
      parent_document: null,
      register_document: null,
      patta_chitta_doc: null,
      ec_document: null,
      panchayat_document: null,
      engineer_estimate_doc: null,
      gst_document: null,
      itr_document: null,
      msme_document: null,
      payslip: null,
      photo: null,
      others: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch('dob');

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getHomeLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
        setSelectedState(loan.state);
        setPresentState(loan.present_state);
        setOfficeState(loan.office_state);
        setClinicState(loan.clinic_state);
        setHospitalState(loan.hospital_state);
        setCompanyName(loan.company_name);
        setBankName(loan.bank_name);
      } catch (error) {
        console.error("Error fetching home loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!officeState) {
      setOfficeCityOptions([]);
      setOfficePincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === officeState
      );

      const officeCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setOfficeCityOptions(officeCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === officeState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setOfficePincodeOptions(uniqueOptions);
    }
        if (!clinicState) {
      setClinicCityOptions([]);
      setClinicPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === clinicState
      );

      const clinicCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setClinicCityOptions(clinicCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === clinicState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setClinicPincodeOptions(uniqueOptions);
    }

    if (!hospitalState) {
      setHospitalCityOptions([]);
      setHospitalPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === hospitalState
      );

      const hospitalCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setHospitalCityOptions(hospitalCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === hospitalState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setHospitalPincodeOptions(uniqueOptions);
    }
  }, [selectedState, presentState, officeState, clinicState, hospitalState,cities, pincodenumber]);

  useEffect(() => {
    if (companyLists.length > 0 && companyName) {
      const matchedCompany = companyLists.find(c => c.label === companyName);
      if (matchedCompany) {
        setCompanyId(matchedCompany.value);
      }
    }
  }, [companyLists, companyName]);

  const fetchCompanies = async () => {
    try {
      const response = await getAllCompanies();
      const companyData = response.data.map((company) => ({
        value: company.company_id,
        label: company.company_name,
      }));
      companyData.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyLists(companyData);
      const matchedCompany = companyData.find(c => c.label === companyName);
    if (matchedCompany) {
      setCompanyId(matchedCompany.value); 
    }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);
  
  useEffect(() => {
    const fetchBusinessLoanBanks = async () => {
      try {
        const response = await getBusinessLoanBankList();
        const banksData = response.data.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setBusinessLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching business loan banks:", error);
      }
    };
    fetchBusinessLoanBanks();
  }, []);

  useEffect(() => {
    const fetchDoctorLoanBanks = async () => {
      try {
        const response = await getDoctorLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setDoctorLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching doctor loan banks:", error);
      }
    };
    fetchDoctorLoanBanks();
  }, []);

  useEffect(() => {
    const fetchPersonalLoanBanks = async () => {
      try {
        const response = await getPersonalLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setPersonalLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching personal loan banks:", error);
      }
    };
    fetchPersonalLoanBanks();
  }, []);

  useEffect(() => {
    const fetchNriLoanBanks = async () => {
      try {
        const response = await getNriLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setNriLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching nri loan banks:", error);
      }
    };
    fetchNriLoanBanks();
  }, []);

  useEffect(() => {
    const id =
      Array.isArray(selectedCompanyId) && selectedCompanyId.length === 0
        ? companyId
        : selectedCompanyId || companyId;
    if (!id || (Array.isArray(id) && id.length === 0)) return;
    const fetchCompanyByIdWithBanks = async () => {
      try {
        const response = await getAllHomeLoanBanks(id);
        const bankList = response.data.bank_list;

        const formattedBanks = bankList.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));

        setBankLists(formattedBanks);
      } catch (error) {
        console.error("Error fetching bank:", error);
      }
    };

    fetchCompanyByIdWithBanks();
  }, [selectedCompanyId, companyId]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleOfficeStateChange = (selectedOption) => {
    setOfficeState(selectedOption?.value || null);
    setValue("office_state", selectedOption?.value || "");
  };

  const getSelectedOfficeStateValue = () => {
    return stateOptions.find((option) => option.value === officeState);
  };

  const handleClinicStateChange = (selectedOption) => {
    setClinicState(selectedOption?.value || null);
    setValue("clinic_state", selectedOption?.value || "");
  };

  const getSelectedClinicStateValue = () => {
    return stateOptions.find((option) => option.value === clinicState);
  };

  const handleHospitalStateChange = (selectedOption) => {
    setHospitalState(selectedOption?.value || null);
    setValue("hospital_state", selectedOption?.value || "");
  };

  const getSelectedHospitalStateValue = () => {
    return stateOptions.find((option) => option.value === hospitalState);
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompanyId(selectedOption?.value || null);
    setCompanyName(selectedOption?.label || null);
    setValue("company_name", selectedOption?.label || "");
    setBankName("");
    setValue("bank_name", "");
  };

  const getSelectedCompanyValue = () => {
    return companyLists.find((option) => option.label === companyName);
  };

  const handleBankChange = (selectedOption) => {
    setBankName(selectedOption?.value || null);
    setValue("bank_name", selectedOption?.value || "");
  };

  const getSelectedBankValue = () => {
    // if (!bankName) return null;
    return bankLists.find((option) => option.value === bankName) || null;
  };

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getHomeLoanByEmail(email);
        console.log(data);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getHomeLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age >= 0) {
        setValue("age", age);
      } else {
        setValue("age", "");
      }
    }
  }, [dob, setValue]);

    const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const handleCompanyButtonClick = () => {
     setIsViewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateHomeLoan(id, formDataToSend);
      setLoading(false);
      navigate("/homeloanlist", {
        state: { successMessage: "Home loan updated successfully!" },
      });
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === "string") {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        } else if (errorMessage.includes("Mobile number already exists")) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
        } else {
          setLoading(false);
          console.error("Error updating home loan:", errorMessage);
          toast.error("Failed to update the home loan. Please try again.");
        }
      } else {
        setLoading(false);
        console.error("Error updating home loan:", error);
        toast.error("Failed to update the home loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getHomeLoanById(id);
      let url = loan[documentType];

      if (url) {
        url = decodeURIComponent(url);
        window.open(url, "_blank");
      } else {
        toast.warn(`No file available`);
        console.warn(`No URL found for document type: ${documentType}`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };

  const handleDownloadClick = async (documentType) => {
    try {
      const loan = await getHomeLoanById(id);
      let url = loan[documentType];

      if (!url) {
        toast.warn("No file available");
        return;
      }

      url = decodeURIComponent(url);

      // Auto-upgrade to HTTPS in production
      if (window.location.hostname !== "localhost" && url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }

      // Fetch blob if local or same-origin, otherwise direct link download
      const isLocalOrSameOrigin = url.startsWith(window.location.origin) || window.location.hostname === "localhost";

      if (isLocalOrSameOrigin) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch the document");
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${documentType}_${id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

      } else {
        // Cross-origin server file
        const link = document.createElement("a");
        link.href = url;
        const fileName = url.split("/").pop() || `${documentType}_${id}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    } catch (error) {
      console.error(`Error downloading ${documentType} document:`, error);
      toast.error("Failed to download document");
    }
  };

  const handleStepChange = async (newStep) => {
    try {
      if (newStep === 1) {
        const isValidStep0 = await methods.trigger();
        if (isValidStep0) {
          if (emailExists) {
            toast.error("Email already exists. Please use a different email.");
            return;
          }
          if (mobileExists) {
            toast.error(
              "Mobile number already exists. Please use a different mobile number."
            );
            return;
          }
          setActiveStep(newStep);
        } else {
          console.log(
            "Please fix validation errors before moving to the next step."
          );
        }
      } else if (newStep === 2) {
        const isValidStep1 = await methods.trigger();
        if (isValidStep1) {
          setActiveStep(newStep);
        } else {
          console.log(
            "Please fix validation errors before moving to the next step."
          );
        }
      } else {
        setActiveStep(newStep);
      }
    } catch (error) {
      console.error("Error handling step change:", error);
    }
  };

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div
            className="edit-back-text"
            onClick={() => navigate("/homeloanlist")}
          >
            &lt; Go Back
          </div>
        </div>
      )}
      <h2>Home Loan</h2>
      <FormProvider {...methods}>
        {loading}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                <Col md={6}>
                  <LabeledInput
                    label="Loan ID"
                    name="form_id"
                    disabled={true}
                    style={{
                      backgroundColor: "#f0f0f0",
                      color: "#808080",
                    }}
                    registerOptions={{}}
                  />
                </Col>
                  {adminRole !== "customer" && ( 
                    <>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee ID"
                          name="created_id"
                          disabled={true}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#808080",
                          }}
                          registerOptions={{}}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee"
                          name="created_by"
                          disabled={true}
                          style={{
                            backgroundColor: "#f0f0f0",
                            color: "#808080",
                          }}
                          registerOptions={{}}
                        />
                      </Col>
                    </>
                  )}
                  {adminRole === "admin" && (
                    <Col md={6}>
                      <LabeledSelect
                        name="assigned_to"
                        label="Assign to"
                        options={employeeOptions}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.assigned_to?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="status"
                      label="Lead Status"
                      options={[
                        { value: "Open", label: "Open" },
                        { value: "In Process", label: "In Process" },
                        { value: "Pending", label: "Pending" },
                        { value: "Approved", label: "Approved" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      registerOptions={{
                        required: "Selection is required",
                        onChange: (e) => {
                          handleStatusChange(e);
                          setValue("status", e.target.value);
                        },
                      }}
                      disabled={adminRole === "customer"}
                      error={errors.status?.message}
                      required
                    />
                  </Col>
                  {watch("status") === "Rejected" && (
                    <Col md={6}>
                      <LabeledDropDown
                        name="rejected_reason"
                        label="Rejected Reason"
                        options={[
                          {
                            value: "CIBIL issue & more than 3 enquiries",
                            label: "CIBIL issue & more than 3 enquiries",
                          },
                          {
                            value: "Recent loan/settlement",
                            label: "Recent loan/settlement",
                          },
                          { value: "Recent DPD", label: "Recent DPD" },
                          {
                            value: "Overdue / Previous loan (HL/PL/BL/CL)",
                            label: "Overdue / Previous loan (HL/PL/BL/CL)",
                          },
                          {
                            value: "Lowest CIBIL score",
                            label: "Lowest CIBIL score",
                          },
                          {
                            value: "Guarantor CIBIL score / Co-Applicant issue",
                            label: "Guarantor CIBIL score / Co-Applicant issue",
                          },
                          {
                            value: "Pincode / Salary / Age criteria not met",
                            label: "Pincode / Salary / Age criteria not met",
                          },
                          {
                            value: "Can apply after 3 months",
                            label: "Can apply after 3 months",
                          },
                          {
                            value: "Never eligible for loan",
                            label: "Never eligible for loan",
                          },
                          {
                            value: "Credit card overdue",
                            label: "Credit card overdue",
                          },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.rejected_reason?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      label="Name"
                      type="text"
                      name="name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Date of Birth"
                      type="date"
                      name="dob"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput label="Age" type="number" name="age" readOnly />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "Single", label: "Single" },
                        { value: "Married", label: "Married" },
                        { value: "Divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("marital_status", e.target.value);
                        },
                      }}
                      error={errors.maritalStatus?.message}
                    />
                  </Col>
                  {watch("marital_status") === "Married" && (
                    <Col md={6}>
                      <LabeledInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.fieldRequired(
                          "Spouse Name"
                        )}
                        error={errors.spouse_name?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      label="Mobile Number"
                      type="tel"
                      name="mobile"
                      registerOptions={validationRules.mobile}
                      error={errors.mobile?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Email"
                      type="email"
                      name="email"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        {
                          value: "OwnedByMe/Spouse",
                          label: "OwnedByMe/Spouse",
                        },
                        {
                          value: "OwnedByMy/Parents",
                          label: "OwnedByMy/Parents",
                        },
                        { value: "Rent", label: "Rent" },
                        { value: "PG", label: "PG" },
                        { value: "Hostel", label: "Hostel" },
                        { value: "Bachelor", label: "Bachelor" },
                        { value: "Company_Provided", label: "Company Provide" },
                      ]}
                      registerOptions={{
                        required: "Residence type is required",
                      }}
                      error={errors.residence_type?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Present Staying Address"
                      type="text"
                      name="address"
                      registerOptions={{
                        required: "Present Address is required",
                      }}
                      error={errors.address?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="landmark"
                      label="Landmark"
                      type="text"
                      registerOptions={{ required: "Landmark is required" }}
                      error={errors.landmark?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelectAgent
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="present_address_adhaar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.present_address_adhaar?.message}
                      required
                    />
                  </Col>
                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="present_address"
                          label="Present Aadhaar Address"
                          registerOptions={{
                            required: "Address is required",
                          }}
                          error={errors.present_address?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_city"
                          label="City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="present_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                          error={errors.present_pincode?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="present_landmark"
                          label="Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.present_landmark?.message}
                          required
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}

            {activeStep === 1 && (
              <div className="sections loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="number"
                      registerOptions={validationRules.homeLoanAmount}
                      error={errors.required_loan_amount?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="existing_emi_amount"
                      label="Total Existing Emi"
                      type="number"
                      registerOptions={{
                        required: "This Existing Emi is required",
                      }}
                      error={errors.existing_emi_amount?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="are_you"
                      label="Are You?"
                      options={[
                        { value: "Salaried", label: "Salaried" },
                        { value: "SelfEmployed", label: "Self Employed" },
                        // { value: "Doctor", label: "Doctor" },
                        // { value: "Nri", label: "Nri" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.are_you?.message}
                    />
                  </Col>
                  {(watch("are_you") === "Salaried" ||
                    watch("are_you") === "Nri") && (
                    <>
                      <Col md={6}>
                        <LabeledSelect
                          name="company_name"
                          label="Working Company Name"
                          options={companyLists}
                          value={getSelectedCompanyValue()}
                          onChange={handleCompanyChange}
                          addButtonLabel="+ Add Company"
                          onAddButtonClick={handleCompanyButtonClick}
                        />
                      </Col>
                      {watch("company_name") === "Others" && (
                        <Col md={6}>
                          <LabeledInput
                            name="others_company"
                            label="Other's Company Name"
                          />
                        </Col>
                      )}
                      {adminRole !==  "customer" &&
                       watch("are_you") === "Salaried" &&
                        (watch("company_name") === "Others" || bankLists.length < 1) && (
                          <Col md={6}>
                            <LabeledSelect
                              name="bank_name"
                              label="Bank Name"
                              options={personalLoanBanks}
                            />
                          </Col>
                        )}
                      {adminRole !==  "customer" &&
                        watch("are_you") === "Nri" &&
                        watch("company_name") === "Others" && (
                          <Col md={6}>
                            <LabeledSelect
                              name="bank_name"
                              label="Bank Name"
                              options={nriLoanBanks}
                            />
                          </Col>
                        )}
                     {adminRole !==  "customer" &&
                      (watch("company_name") !== "Others" && bankLists.length > 0) && (
                        <Col md={6}>
                          <LabeledSelect
                            name="bank_name"
                            label="Bank Name"
                            options={bankLists}
                            value={getSelectedBankValue()}
                            onChange={handleBankChange}
                          />
                        </Col>
                      )}
                    </>
                  )}

                  {(watch("are_you") === "Salaried" ||
                    watch("are_you") === "Doctor") && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="net_salary"
                          label="Net Salary"
                          type="number"
                          registerOptions={{
                            required: "Net salary is required",
                          }}
                          error={errors.net_salary?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledDropDown
                          name="is_pf_deducted"
                          label="Are You Looking for Balance Transfer?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                          error={errors.is_pf_deducted?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="total_experience"
                          label="Total Year of Experience"
                          registerOptions={{
                            required: "Total year of experience is required",
                          }}
                          error={errors.total_experience?.message}
                          required
                        />
                      </Col>
                    </>
                  )}

                  {watch("are_you") === "Salaried" && (
                    <>
                      <Col md={6}>
                        <LabeledDropDown
                          name="company_type"
                          label="Company Type"
                          options={[
                            {
                              value: "PrivateLimited",
                              label: "Private Limited",
                            },
                            { value: "PublicLimited", label: "Public Limited" },
                            { value: "State", label: "State" },
                            { value: "CentralGovt", label: "Central Govt" },
                            {
                              value: "Proprietorship",
                              label: "Proprietorship",
                            },
                            { value: "Partnership", label: "Partnership" },
                          ]}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="type_your_designation"
                          label=" Type Your Designation"
                          registerOptions={{
                            required: "Type your designation is required",
                          }}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="office_address"
                          label="Office Address"
                          registerOptions={{ required: "Enter Address" }}
                          error={errors.office_address3?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="office_landmark"
                          label="Office Landmark"
                          registerOptions={{
                            required: "Landmark is required",
                          }}
                          error={errors.office_landmark?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="office_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedOfficeStateValue()}
                          onChange={handleOfficeStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.office_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="office_city"
                          label="City"
                          options={officeCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.office_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="office_pincode"
                          label="Pincode"
                          options={officePincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                        />
                      </Col>
                    </>
                  )}

                  {watch("are_you") === "SelfEmployed" && (
                    <>
                      {adminRole !==  "customer" &&(
                        <Col md={6}>
                          <LabeledSelect
                            name="bank_name"
                            label="Bank Name"
                            options={businessLoanBanks}
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <LabeledDropDown
                          name="register_company"
                          label="Your Company Registered As"
                          options={[
                            {
                              value: "private_limited",
                              label: "Private Limited",
                            },
                            {
                              value: "proprietorship",
                              label: "Proprietorship",
                            },
                            { value: "partnership", label: "Partnership" },
                            { value: "llp", label: "LLP" },
                            {
                              value: "not_registered",
                              label: "NOT Registered",
                            },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="turnover"
                          label="Annual Turn Over"
                          type="number"
                          registerOptions={validationRules.turnover}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledDropDown
                          name="business_type"
                          label="Nature of Business"
                          options={[
                            { value: "manufacturing", label: "Manufacturing" },
                            { value: "retails", label: "Retails" },
                            { value: "service", label: "Service" },
                            { value: "agriculture", label: "Agriculture" },
                            { value: "real_estate", label: "Real Estate" },
                            {
                              value: "transportation",
                              label: "Transportation",
                            },
                            { value: "e-Commerce", label: "E-Commerce" },
                            { value: "others", label: "Others" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>
                      {watch("business_type") === "others" && (
                        <Col md={6}>
                          <LabeledInput
                            name="description"
                            label="Others"
                            registerOptions={{
                              required: "Others is required",
                            }}
                            required
                          />
                        </Col>
                      )}

                      <Col md={6}>
                        <LabeledDropDown
                          name="business_place"
                          label="Business Place"
                          options={[
                            { value: "Own", label: "Own" },
                            { value: "Rent", label: "Rent" },
                            { value: "lease", label: "Lease" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>

                      {watch("business_place") === "Own" && (
                        <>
                          <Col md={6}>
                            <LabeledInput
                              name="businessStart_year"
                              label="Business Start Year"
                              type="number"
                              registerOptions={{
                                required: "Business Start Year is required",
                              }}
                              required
                            />
                          </Col>

                          <Col md={6}>
                            <LabeledDropDown
                              name="gst_registered"
                              label="GST Registered"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                          {watch("gst_registered") === "Yes" && (
                            <Col md={6}>
                              <LabeledInput
                                name="gst_registerd_year"
                                label="GST Registered Year"
                                type="number"
                                registerOptions={{
                                  required: "GST Registered Year is required",
                                  validate: {
                                    notFuture: (value) => {
                                      const currentYear =
                                        new Date().getFullYear();
                                      return (
                                        value <= currentYear ||
                                        "Year cannot be in the future"
                                      );
                                    },
                                  },
                                }}
                                required
                              />
                            </Col>
                          )}
                          <Col md={6}>
                            <LabeledDropDown
                              name="msme_registered"
                              label="MSME Registers"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledDropDown
                              name="filling_itr"
                              label="Are You Filling ITR?"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </>
                  )}

                  {watch("are_you") === "Doctor" && (
                    <>
                      {adminRole !==  "customer" &&(
                        <Col md={6}>
                          <LabeledSelect
                            name="bank_name"
                            label="Bank Name"
                            options={doctorLoanBanks}
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <LabeledDropDown
                          name="degree"
                          label="Choose Degree"
                          options={[
                            { value: "MBBS", label: "MBBS" },
                            { value: "MD&Above", label: "MD & Above" },
                            { value: "Surgeon", label: "Surgeon" },
                            { value: "BDS/MDS", label: "BDS/MDS" },
                            { value: "Others", label: "Others" },
                          ]}
                          registerOptions={{
                            required: "This selection is required",
                          }}
                          error={errors.degree?.message}
                        />
                      </Col>
                      {watch("degree") === "MBBS" && (
                        <>
                          <Col md={6}>
                            <LabeledInput
                              name="mbbs_completed_year"
                              label="MBBS Completed Year"
                              type="number"
                              registerOptions={{
                                required: "MBBS Completed Year is required",
                                validate: (value) => {
                                  const currentYear = new Date().getFullYear();
                                  if (
                                    isNaN(value) ||
                                    value < 1990 ||
                                    value >= currentYear
                                  ) {
                                    return `Please enter a year between 1990 and ${
                                      currentYear - 1
                                    }`;
                                  }
                                  return true;
                                },
                              }}
                              error={errors.mbbs_completed_year?.message}
                            />
                          </Col>
                        </>
                      )}
                      {watch("degree") === "Others" && (
                        <Col md={6}>
                          <LabeledInput
                            name="degree_others"
                            label="Degree Others"
                            registerOptions={{
                              required: "Degree others is required",
                            }}
                            error={errors.degree_others?.message}
                          />
                          required
                        </Col>
                      )}
                      <Col md={6}>
                        <LabeledDropDown
                          name="work_type"
                          label="Work Type?"
                          options={[
                            { value: "Salaried", label: "Salaried" },
                            { value: "Own Clinic", label: "Own Clinic" },
                          ]}
                          registerOptions={{
                            required: "This selection is required",
                          }}
                          error={errors.work_type?.message}
                        />
                      </Col>
                      {watch("work_type") === "Own Clinic" && (
                        <>
                          <Col md={6}>
                            <LabeledInput
                              name="service_experience"
                              label="Service Experience"
                              registerOptions={{
                                required: "Service experience is required",
                              }}
                              error={errors.service_experience?.message}
                              required
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledInput
                              name="clinic_name"
                              label="Clinic Name"
                              registerOptions={{
                                required: "Clinic name is required",
                              }}
                              error={errors.clinic_name?.message}
                              required
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledInput
                              name="clinic_address"
                              label="Clinic Address"
                              registerOptions={{
                                required: "Clinic address is required",
                              }}
                              error={errors.clinic_address?.message}
                              required
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelect
                              name="clinic_state"
                              label="Clinic State"
                              options={stateOptions}
                              value={getSelectedClinicStateValue()}
                              onChange={handleClinicStateChange}
                              registerOptions={{
                                required: "State is required",
                              }}
                              error={errors.clinic_state?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelect
                              name="clinic_city"
                              label="Clinic City"
                              options={clinicCityOptions}
                              registerOptions={{ required: "City is required" }}
                              error={errors.clinic_city?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelectAgent
                              name="clinic_pincode"
                              label="Clinic Pincode"
                              options={clinicPincodeOptions}
                              registerOptions={{
                                required: "Pincode is required",
                              }}
                              error={errors.clinic_pincode?.message}
                            />
                          </Col>
                        </>
                      )}
                      {watch("work_type") === "Salaried" && (
                        <>
                          <Col md={6}>
                            <LabeledInput
                              name="hospital_name"
                              label="Working Hospital Name"
                              registerOptions={{
                                required: "Hospital name is required",
                              }}
                              error={errors.hospital_name?.message}
                              required
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledInput
                              name="hospital_address"
                              label="Hospital Address"
                              registerOptions={{
                                required: "Hospital address is required",
                              }}
                              error={errors.hospital_address?.message}
                              required
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelect
                              name="hospital_state"
                              label="Hospital State"
                              options={stateOptions}
                              value={getSelectedHospitalStateValue()}
                              onChange={handleHospitalStateChange}
                              registerOptions={{
                                required: "State is required",
                              }}
                              error={errors.hospital_state?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelect
                              name="hospital_city"
                              label="Hospital City"
                              options={hospitalCityOptions}
                              registerOptions={{ required: "City is required" }}
                              error={errors.hospital_city?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <LabeledSelectAgent
                              name="hospital_pincode"
                              label="Hospital Pincode"
                              options={hospitalPincodeOptions}
                              registerOptions={{
                                required: "Pincode is required",
                              }}
                              error={errors.hospital_pincode?.message}
                            />
                          </Col>
                        </>
                      )}
                    </>
                  )}

                  {watch("are_you") === "Nri" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="working_country"
                          label="Working Country"
                          registerOptions={{
                            required: "Working country is required",
                          }}
                          error={errors.working_country?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="net_salary_indian_rupees"
                          label="Net salary in Indian Rupees"
                          type="number"
                          registerOptions={{
                            required: "Net salary is required",
                          }}
                          error={errors.net_salary_indian_rupees?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledDropDown
                          name="present_india"
                          label="Are You Present in India?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                          required
                        />
                      </Col>
                    </>
                  )}

                  <Col md={6}>
                    <LabeledDropDown
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>

                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <LabeledInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    {(watch("are_you") === "Salaried" ||
                      watch("are_you") === "SelfEmployed") && (
                      <>
                        <div className="document-upload-group">
                          <label htmlFor="photo" className="document-label required">
                            Photo <br/> (Selfie Recommend)
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.photo}
                              type="file"
                              name="photo"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.photo && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("photo")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("photo")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("photo")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label htmlFor="aadhar" className="document-label required">
                            Aadhaar/eAadhaar
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.aadhar}
                              label="Aadhaar Card"
                              type="file"
                              name="aadhar"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.aadhar && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("aadhar")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("aadhar")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("aadhar")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label htmlFor="pan" className="document-label required">
                            PAN Card
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.pan}
                              label="PAN Card"
                              type="file"
                              name="pan"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.pan && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("pan")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("pan")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("pan")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="account_Statement"
                            className="document-label required"
                          >
                            {watch("are_you") === "Salaried" ? (
                              <>
                                Account Statement <br /> (Last 6 Months)
                              </>
                            ) : (
                              <>
                                Account Statement <br /> (Last 12 Months)
                              </>
                            )}
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.account_Statement}
                              name="account_Statement"
                              label="6 Month Account Statement"
                              type="file"
                              className="form-control-file"
                              accept=".pdf"
                              onChange={handleFileChange}
                            />
                            {files.account_Statement && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("account_Statement")}
                              />
                            )}
                          </div>
                          <span className="file-upload-message">
                            Upload only PDF files & without password
                          </span>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("account_Statement")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleDownloadClick("account_Statement")
                              }
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    {(watch("are_you") === "SelfEmployed") && (
                      <>
                        <div className="document-upload-group">
                          <label
                            htmlFor="gst_document"
                            className="document-label"
                          >
                            GST Registration or Any
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.gst_document}
                              type="file"
                              name="gst_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.gst_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("gst_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("gst_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("gst_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="msme_document"
                            className="document-label"
                          >
                            GST 3B <br /> (Last 18 Months) 
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.msme_document}
                              type="file"
                              name="msme_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.msme_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("msme_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("msme_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("msme_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="itr_document"
                            className="document-label"
                          >
                            ITR 
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.itr_document}
                              type="file"
                              name="itr_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.itr_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("itr_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("itr_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("itr_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="others"
                            className="document-label"
                          >
                            Others
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.others}
                              type="file"
                              name="others"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.others && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("others")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("others")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("others")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    {(watch("are_you") === "Salaried") && (
                      <>
                        <div className="document-upload-group">
                          <label
                            htmlFor="payslip"
                            className="document-label"
                          >
                            Payslip (Last 3 Months)
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.payslip}
                              type="file"
                              name="payslip"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.payslip && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("payslip")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("payslip")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("payslip")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="others"
                            className="document-label"
                          >
                            Others
                          </label>
                          <Col md={12} className="document-dropdown-file">
                            <LabeledSelect
                              name="other"
                              options={[
                                { value: "Employee ID", label: "Employee ID" },
                                { value: "Form16", label: "Form 16" },
                                { value: "Form26AS", label: "Form 26 AS" },
                                {
                                  value: "Previous Loan Statement",
                                  label: "Previous Loan Statement",
                                },
                              ]}
                            />
                            </Col>
                            <div className="document-file-container">
                              <input
                                ref={fileRefs.others}
                                type="file"
                                name="others"
                                onChange={handleFileChange}
                                className="form-control-file"
                              />
                              {files.others && (
                                <FaTrashAlt
                                  className="trash-icon"
                                  title="Remove file"
                                  onClick={() => handleClearFile("others")}
                                />
                              )}
                            </div>
                            <div className="button-group">
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleViewClick("others")}
                              >
                                View
                              </button>
                              <button
                                type="button"
                                className="view-btn"
                                onClick={() => handleDownloadClick("others")}
                              >
                                Download
                              </button>
                            </div>
                        </div>
                      </>
                    )}
                    <div>
                      <h4
                        className="pricing-content-subtitle pricing-dropdown-btn"
                        style={{ marginTop: "-10px" }}
                        onClick={() => setShowDocuments(!showDocuments)}
                      >
                        <span className="pricing-icon">
                          Upload Property Documents
                        </span>
                        {showDocuments ? <FaMinusCircle /> : <FaPlusCircle />} 
                      </h4>
                    </div>
                    {showDocuments && (
                      <div className="sections document-upload-sections">
                        <div className="document-upload-group">
                          <label
                            htmlFor="dtcp_document"
                            className="document-label"
                          >
                            Dtcp Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.dtcp_document}
                              type="file"
                              name="dtcp_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.dtcp_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("dtcp_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("dtcp_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("dtcp_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="panchayat_document"
                            className="document-label"
                          >
                            Panchayat Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.panchayat_document}
                              type="file"
                              name="panchayat_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.panchayat_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("panchayat_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("panchayat_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleDownloadClick("panchayat_document")
                              }
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="parent_document"
                            className="document-label"
                          >
                            Parent Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.parent_document}
                              type="file"
                              name="parent_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.parent_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("parent_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("parent_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("parent_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="register_document"
                            className="document-label"
                          >
                            Register Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.register_document}
                              type="file"
                              name="register_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.register_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("register_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("register_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleDownloadClick("register_document")
                              }
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="fmb_document"
                            className="document-label"
                          >
                            FMB Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.fmb_document}
                              type="file"
                              name="fmb_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.fmb_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("fmb_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("fmb_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("fmb_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="patta_chitta_doc"
                            className="document-label"
                          >
                            Patta/Chitta Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.patta_chitta_doc}
                              type="file"
                              name="patta_chitta_doc"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.patta_chitta_doc && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("patta_chitta_doc")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("patta_chitta_doc")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleDownloadClick("patta_chitta_doc")
                              }
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="engineer_estimate_doc"
                            className="document-label"
                          >
                            Engineer Estimate / Validation <br /> Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.engineer_estimate_doc}
                              type="file"
                              name="engineer_estimate_doc"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.engineer_estimate_doc && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("engineer_estimate_doc")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleViewClick("engineer_estimate_doc")
                              }
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() =>
                                handleDownloadClick("engineer_estimate_doc")
                              }
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="ec_document"
                            className="document-label"
                          >
                            EC Recent Document
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.ec_document}
                              type="file"
                              name="ec_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                            />
                            {files.ec_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("ec_document")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("ec_document")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("ec_document")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="success"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Update"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <CreateCompanyModal           
        isOpen={isViewModalOpen}
        onClose={handleCloseModal}
        onCompanyCreated={fetchCompanies} 
      />
      <ToastContainer />
    </div>
  );
};

export default EditHomeLoan;
